<template>
  <span class="coupon-badge">
    <slot></slot>

    <button type="button" class="coupon-badge__close" @click="onButtonClick" v-tooltip="'Remove'">
      <span aria-hidden="true">&times;</span>
    </button>
  </span>
</template>

<script>
export default {
  name: 'coupon-badge',
  methods: {
    onButtonClick() {
      this.$emit('remove');
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-badge {
  background-color: #777777;
  border-radius: 12px;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 0.5em 0 0.7em;

  &__close {
    background: none;
    font-size: 24px;
    height: 24px;
    line-height: 24px;
    padding: 0;
    margin-left: 8px;
  }
}
</style>
